import { ResourceRecorder } from '../src/ResourceRecorder.ts';

export const globalMacrosCSSRecorder: ResourceRecorder = new ResourceRecorder();
export const globalMacrosJSRecorder: ResourceRecorder = new ResourceRecorder();
